import { ReactComponent as DotsVerticalSvg } from '../../assets/icons/dots-vertical.svg';

export const DotsVerticalIcon: SvgIcon = (props) => {
    return <DotsVerticalSvg {...props} />;
};
